import { render } from "./notification.vue?vue&type=template&id=4f589666"
import script from "./notification.js?vue&type=script&lang=js"
export * from "./notification.js?vue&type=script&lang=js"

import "./notification.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__